export function handleWheelOnNumericField(event: WheelEvent) {
  if ((event.currentTarget as HTMLElement).contains(document.activeElement)) {
    event.preventDefault()
  }
}
